export const BLOG_ARTICLES_PER_PAGE = 6;
export const BLOG_RECENT_ARTICLES_LIMIT = 3;
